import type { AgentTheme } from "@bubble/core";
import { ChatBubble } from "./ChatBubble.tsx";

export function SiteStage({
  agentId,
  name,
  theme,
  sample,
  note,
  onAnswered,
}: {
  agentId: string;
  name: string;
  theme: AgentTheme;
  sample: boolean;
  note: string;
  onAnswered?: () => void;
}) {
  const title = theme.title?.trim() || name;
  return (
    <section className="site-stage" aria-label="Preview of the chat on a website">
      <div className="site-frame">
        <div className="site-chrome">
          <span />
          <span />
          <span />
          <p>{sample ? "harbor-and-rye.example" : "your-website.example"}</p>
        </div>
        <div className="site-hero" style={{ borderTopColor: theme.color }}>
          <p className="site-logo">{title}</p>
          <p className="site-nav">{sample ? "Menu · Visit · Orders" : "Home · Help · Contact"}</p>
          <h2>{sample ? "Coffee, roasted this week." : "How the chat looks on your site"}</h2>
          <p>
            {sample
              ? "Harbor & Rye is a sample cafe in Portland. The bubble uses the cafe's notes, so you can ask a real question before you add your own."
              : "The bubble uses your color, greeting, and the files you added. Visitors on your site see this same chat."}
          </p>
        </div>
      </div>
      <ChatBubble agentId={agentId} name={name} theme={theme} note={note} placement="stage" defaultOpen onAnswered={onAnswered} />
    </section>
  );
}
